import { createContext, useCallback, useContext, useMemo } from 'react';
import { IMixpanel, mixpanel } from './mixpanel';

export interface IAnalytics {
  mixpanel: IMixpanel;
}

export const analytics: IAnalytics = {
  mixpanel,
};

export const AnalyticsContext = createContext(analytics);

export const useAnalytics = () => {
  const analytics = useContext(AnalyticsContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const trackEvent = useCallback(
    ((eventName, properties: Record<string, unknown> = {}) => {
      return analytics.mixpanel.trackEvent(eventName, {
        ...analytics.mixpanel.defaultProperties,
        ...properties,
      });
    }) satisfies IMixpanel['trackEvent'],
    [analytics.mixpanel],
  );
  return useMemo(
    () => ({
      ...analytics,
      mixpanel: {
        ...analytics.mixpanel,
        trackEvent,
      },
    }),
    [analytics, trackEvent],
  );
};
